import { CatalogSearchPage } from '~/features/experiments/catalog_search_improvements/components/catalog-search-page';

export { getStaticProps } from '~/pages/catalog';

export default CatalogSearchPage;
